import React from "react";
import { Link } from "react-router-dom";
import { websitePaths } from "../../routes/websitePaths";
import "../../components/website/sections/ProjectCategoryPage.css";

const completedProjects = [
  {
    title: "Premium Villa Turnkey Build",
    location: "Lucknow",
    description:
      "End-to-end planning, structural execution, and interior finishing delivered within a milestone-based schedule.",
    image:
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Commercial Office Fit-Out",
    location: "Noida",
    description:
      "Workspace construction and finishing package completed with coordinated MEP, civil, and interior teams.",
    image:
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Industrial Shed And Utility Block",
    location: "Kanpur",
    description:
      "Heavy-duty site execution focused on safety, workflow efficiency, and reliable structural performance.",
    image:
      "https://images.unsplash.com/photo-1513828583688-c52646db42da?auto=format&fit=crop&w=1200&q=80",
  },
];

const deliveryHighlights = [
  {
    title: "Residential Expertise",
    description:
      "Custom homes, villas, and renovation assignments delivered with practical planning and finish quality.",
  },
  {
    title: "Commercial Readiness",
    description:
      "Office, retail, and mixed-use spaces executed around timelines, usability, and brand presentation.",
  },
  {
    title: "Industrial Capability",
    description:
      "Warehouses and operational sites completed with layout discipline, durability, and site coordination.",
  },
];

const ProjectsCompletedPage: React.FC = () => {
  return (
    <section className='project-category-page website-page'>
      <div className='project-category-hero website-page-hero text-center'>
        <div className='container'>
          <p className='website-page-kicker mb-2'>Projects Completed</p>
          <h2 className='project-page-title website-page-title mb-3'>
            Delivery record built across residential, commercial, and industrial
            work.
          </h2>
          <p className='project-page-subtitle website-page-subtitle mx-auto mb-0'>
            A snapshot of the construction work we have delivered across homes,
            commercial spaces, and industrial sites with structured supervision
            and quality control.
          </p>
        </div>
      </div>

      <div className='container website-page-content'>
        <div className='row g-3 mb-4'>
          {deliveryHighlights.map((item) => (
            <div className='col-md-4' key={item.title}>
              <div className='website-metric-card h-100'>
                <h5>{item.title}</h5>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className='row g-4'>
          {completedProjects.map((project) => (
            <div
              className='col-md-6 col-lg-4'
              key={`${project.title}-${project.location}`}
            >
              <article className='card project-show-card h-100 border-0'>
                <img
                  src={project.image}
                  alt={project.title}
                  className='card-img-top project-show-image'
                />
                <div className='card-body d-flex flex-column'>
                  <h5 className='card-title mb-2'>{project.title}</h5>
                  <p className='project-show-location mb-2'>
                    <i className='bi bi-geo-alt-fill me-2'></i>
                    {project.location}
                  </p>
                  <p className='card-text mb-3'>{project.description}</p>
                  <Link
                    to={websitePaths.contact}
                    className='btn brand-btn-outline mt-auto align-self-start'
                  >
                    Discuss A Similar Project
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </div>

        <div className='project-category-cta mt-4'>
          <div>
            <span className='website-section-kicker'>
              Need Project Support?
            </span>
            <h3 className='mb-2'>
              Planning a new build, upgrade, or multi-phase rollout?
            </h3>
            <p className='mb-0'>
              Share your scope with our team and we will recommend the right
              execution plan for your site.
            </p>
          </div>
          <Link to={websitePaths.contact} className='btn brand-btn-primary'>
            Talk To Our Team
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProjectsCompletedPage;
